import React from "react";

/* The dashboard rail's icons, transcribed from the design's own nav markup (Dashboard Screen.html). */
const Svg = ({ children, className = "", filled = false, weight = 1.8 }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke={filled ? undefined : "currentColor"}
    strokeWidth={filled ? undefined : weight}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    {children}
  </svg>
);

export const DashboardIcon = (p) => (
  <Svg {...p} weight={1.9}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
  </Svg>
);

export const BusinessesIcon = (p) => (
  <Svg {...p}>
    <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-4h6v4" />
    <path d="M9 10h.01M15 10h.01M9 13.5h.01M15 13.5h.01" />
  </Svg>
);

export const MembershipIcon = (p) => (
  <Svg {...p} filled>
    <path d="M6 3h12l3 5-9 12L3 8l3-5z" opacity="0.9" />
  </Svg>
);

export const TradeInformationIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8h.01M11 12h1v4h1" />
  </Svg>
);

export const TradeFinanceIcon = (p) => (
  <Svg {...p}>
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="2.5" />
    <path d="M6 9v6M18 9v6" />
  </Svg>
);

export const TradeRiskIcon = (p) => (
  <Svg {...p}>
    <path d="M12 3l8 3v6c0 4.5-3 7.5-8 9-5-1.5-8-4.5-8-9V6l8-3z" />
    <path d="M9 12l2 2 4-4" />
  </Svg>
);

export const FollowingIcon = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
    <path d="M16 3.5a3.2 3.2 0 010 6M18 14c2.2.6 3.8 2.5 4 5" />
  </Svg>
);

export const RequestsIcon = (p) => (
  <Svg {...p}>
    <rect x="3.5" y="3" width="17" height="18" rx="2" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </Svg>
);

export const BillingIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 10h18M7 15h4" />
  </Svg>
);

export const PurchasedIcon = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="20" r="1.4" />
    <circle cx="18" cy="20" r="1.4" />
    <path d="M2 3h3l2.5 12.5a1.5 1.5 0 001.5 1.2h8a1.5 1.5 0 001.5-1.2L21 7H6" />
  </Svg>
);

export const KnowledgeHubIcon = (p) => (
  <Svg {...p}>
    <path d="M3 8l9-4 9 4-9 4-9-4z" />
    <path d="M6 10v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
  </Svg>
);

export const PaymentRefIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M7 9h10M7 13h6" />
    <path d="M15.5 16.5l2 2 3-3.5" />
  </Svg>
);

export const EnterpriseIcon = (p) => (
  <Svg {...p}>
    <path d="M3 21h18M5 21V5a1 1 0 011-1h8a1 1 0 011 1v16M15 9h4a1 1 0 011 1v11" />
    <path d="M8 8h.01M11 8h.01M8 12h.01M11 12h.01" />
  </Svg>
);

export const HelpIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9.5a2.5 2.5 0 013.5-.5c1.2.8 1 2-.3 2.8-.7.5-1.2.9-1.2 1.7M12 16.5h.01" />
  </Svg>
);

export const LogoutIcon = (p) => (
  <Svg {...p}>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <path d="M16 17l5-5-5-5M21 12H9" />
  </Svg>
);

/* Keyed to the nav model's item names. */
export const NAV_ICONS = {
  Dashboard: DashboardIcon,
  MyBusinesses: BusinessesIcon,
  Membership: MembershipIcon,
  TradeInformation: TradeInformationIcon,
  TradeFinance: TradeFinanceIcon,
  TradeRisk: TradeRiskIcon,
  Following: FollowingIcon,
  Requests: RequestsIcon,
  Billing: BillingIcon,
  Purchased: PurchasedIcon,
  KnowledgeHub: KnowledgeHubIcon,
  PaymentRef: PaymentRefIcon,
  Enterprise: EnterpriseIcon,
  Help: HelpIcon,
};
